var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "availability-filter" }, [
    _c(
      "div",
      { staticClass: "availability-filter__colors" },
      [
        _c("span", [_vm._v("\n      Цвета\n    ")]),
        _c("ui-select", {
          ref: "colors",
          staticClass: "ui-select-colors",
          attrs: {
            value: _vm.activeColor,
            options: _vm.computedColors,
            disabled: _vm.computedColors.length <= 1,
            placeholder: "Выберите цвет"
          },
          on: { "click-input": _vm.onClickColorFilter, change: _vm.chooseColor }
        })
      ],
      1
    ),
    _c("div", { staticClass: "availability-filter__sizes" }, [
      _c("span", [_vm._v("\n      Размеры\n    ")]),
      _c(
        "div",
        { staticClass: "availability-filter__sizes-wrap" },
        [
          _c("ui-select", {
            ref: "sizes",
            staticClass: "ui-select-sizes",
            attrs: {
              value: _vm.ACTIVE_SKU.id,
              options: _vm.computedSizes,
              "empty-value": "Не выбран",
              placeholder: "Выберите размер"
            },
            on: { "click-input": _vm.onClickSizeFilter, change: _vm.chooseSize }
          }),
          _c(
            "div",
            { staticClass: "availability-filter__not-delayed" },
            [
              _c(
                "ui-checkbutton",
                {
                  ref: "inStore",
                  attrs: { value: _vm.isInStore, label: "В наличии" },
                  on: { input: _vm.onInputInStore }
                },
                [
                  _c("f-sprite-icon", {
                    attrs: {
                      slot: "icon",
                      "icon-link": _vm.$options.icons.IconLocation.id
                    },
                    slot: "icon"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm.CITY.hasMetro
      ? _c(
          "div",
          { staticClass: "availability-filter__metro" },
          [
            _c("span", [_vm._v("\n      Метро\n    ")]),
            _c("ui-select", {
              ref: "metro",
              staticClass: "ui-select-metro",
              attrs: {
                options: _vm.metroSpecs,
                "empty-value": "Не выбрана",
                placeholder: "Выберите станцию метро"
              },
              on: { change: _vm.chooseMetro },
              model: {
                value: _vm.metro.value,
                callback: function($$v) {
                  _vm.$set(_vm.metro, "value", $$v)
                },
                expression: "metro.value"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }